<template>
  <div class="language-switcher">
    <el-dropdown @command="handleLanguageChange" trigger="click">
      <span class="language-trigger">
        <i class="el-icon-globe"></i>
        {{ currentLanguageText }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh-CN">
          <i class="el-icon-check" v-if="currentLanguage === 'zh-CN'"></i>
          简体中文
        </el-dropdown-item>
        <el-dropdown-item command="zh-TW">
          <i class="el-icon-check" v-if="currentLanguage === 'zh-TW'"></i>
          繁體中文
        </el-dropdown-item>
        <el-dropdown-item command="en">
          <i class="el-icon-check" v-if="currentLanguage === 'en'"></i>
          English
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: 'LanguageSwitcher',
  mixins: [i18nMixin],
  computed: {
    currentLanguageText() {
      const languageMap = {
        'zh-CN': '简体中文',
        'zh-TW': '繁體中文',
        'en': 'English'
      };
      return languageMap[this.currentLanguage] || '简体中文';
    }
  },
  methods: {
    handleLanguageChange(language) {
      this.switchLanguage(language);
    }
  }
};
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}

.language-trigger {
  cursor: pointer;
  color: #606266;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.language-trigger:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.language-trigger i {
  font-size: 16px;
}

.el-dropdown-menu .el-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.el-dropdown-menu .el-dropdown-item i.el-icon-check {
  color: #409eff;
  font-weight: bold;
}
</style>
